module.exports = __webpack_public_path__ + "sweden.svg?8a861197f3b5ca6dffaf6fdab2723682";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/sweden.svg
// module id = 310
// module chunks = 10